import { AppliaChildRoute, AppliaRoute } from "../../../config/routes/routes";

export const parseRouteTitle = (
	parentNode: AppliaRoute | undefined,
	currentRouteInfo: AppliaRoute | AppliaChildRoute | undefined,
) => {
	let title = "";

	if (
		parentNode &&
		(parentNode.url !== currentRouteInfo?.url || parentNode?.pathName !== currentRouteInfo?.pathName) &&
		parentNode?.label !== currentRouteInfo?.label
	) {
		if (parentNode?.pillarNumber) {
			title = `${currentRouteInfo?.label || ""} - Pillar ${parentNode?.pillarNumber || ""}: ${parentNode?.label || ""}`;
		} else {
			title = `${currentRouteInfo?.label || ""} - ${parentNode?.label || ""}`;
		}
	} else {
		if ((currentRouteInfo as AppliaRoute)?.pillarNumber) {
			title = `Pillar ${(currentRouteInfo as AppliaRoute)?.pillarNumber || ""}: ${currentRouteInfo?.label || ""}`;
		} else {
			title = `${currentRouteInfo?.label || ""}`;
		}
	}

	return title;
};
